import { FC } from 'react'
import { Stack, Typography } from '@dtx-company/design-system/src'
import { Video } from '../../containers/home/Video'
import { useScreenSizeBreakpoints } from '@dtx-company/app/shared/common/src/hooks/useScreenSizeBreakpoints'
import Image from 'next/image'

const logos = [
  {
    src: '/images/smarterQrCodes/logos/compass.svg',
    width: 130,
    height: 60,
    alt: 'Compass'
  },
  {
    src: '/images/smarterQrCodes/logos/nfl.svg',
    width: 50,
    height: 50,
    alt: 'NFL'
  },
  {
    src: '/images/smarterQrCodes/logos/clear.svg',
    width: 120,
    height: 50,
    alt: 'Clear'
  },
  {
    src: '/images/smarterQrCodes/logos/sofi.svg',
    width: 120,
    height: 50,
    alt: 'SoFi'
  },
  {
    src: '/images/smarterQrCodes/logos/corcoran.svg',
    width: 120,
    height: 50,
    alt: 'Corcoran'
  },
  {
    src: '/images/smarterQrCodes/logos/espn.svg',
    width: 100,
    height: 35,
    alt: 'ESPN'
  }
]

export const SmarterQrCodesSection: FC = () => {
  const { isLargeDesktop } = useScreenSizeBreakpoints()
  return (
    <Stack
      sx={{
        mt: 8,
        alignItems: 'center',
        textAlign: 'center',
        gap: 4,
        width: '100%'
      }}
    >
      <Typography variant={'headlineMedium'}>Smarter QR code for business</Typography>
      <Typography>
        Watch why top F500 brands are using Flowcode to drive engagement from the real world
      </Typography>
      <Stack
        sx={{
          width: { xs: '90%', md: '90%', lg: '50%' },
          height: 'auto',
          my: 4
        }}
      >
        <Video
          videoLink={'https://player.vimeo.com/video/1097996525'}
          placeholder={'/images/smarterQrCodes/locg-placeholder-for-video.png'}
          heapId={'F2Upsell_LOCG'}
        />
      </Stack>

      <Stack
        direction={'row'}
        gap={24}
        sx={{
          flexWrap: 'nowrap',
          overflowX: 'hidden',
          width: '100%',
          maxWidth: '100vw',
          justifyContent: 'center',
          alignItems: 'center',
          py: 8,
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 0,
            bottom: 0,
            width: '30%',
            background:
              'linear-gradient(to right, rgba(255, 255, 255, 0.85), rgba(255, 255, 255, 0.4))',
            zIndex: 1,
            pointerEvents: 'none'
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            right: 0,
            top: 0,
            bottom: 0,
            width: '30%',
            background:
              'linear-gradient(to right, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.85))',
            zIndex: 1,
            pointerEvents: 'none'
          }
        }}
      >
        {logos.map(logo => (
          <Image {...logo} key={logo.alt} />
        ))}
        {isLargeDesktop && logos.map(logo => <Image {...logo} key={logo.alt} />)}
      </Stack>
    </Stack>
  )
}
